












// check this out: https://blog.logrocket.com/how-to-write-a-vue-js-app-completely-in-typescript/

// import Vue, { PropType } from 'vue'
import Page from '@/components/layouts/Page.vue'
// import { vxm } from '@/state/index'
import PageSection from '@/components/layouts/PageSection.vue'
import ModalDialog from '@/components/appBase/ModalDialog.vue'
import { wait } from '@/lib/utils/wait'

import {
  defineComponent, reactive, toRefs, computed, onBeforeMount,
} from '@vue/composition-api'

const subPages = [
  { title: 'Deltagere', nav: { name: 'studyCases' } },
  { title: 'Stamdata', nav: { name: 'studyCases' } },
]

const initialState: {
  loading: boolean;
} = {
  loading: false,
}

const StudyPage = defineComponent({
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Page, PageSection, ModalDialog,
  },
  props: {
    studyId: {
      type: String,
      default: '',
    },
  },

  setup(props, context) {
    const state = reactive({ ...initialState })

    const study = computed(() => context.root.$store.getters['studies/getById'](props.studyId))

    const getPageTitle = computed(() => {
      const title = study.value === undefined ? '' : study.value.title
      return title
    })

    onBeforeMount(() => {
      wait(1).then(() => {
        try {
          if (context.root.$store.getters['studies/getById'](props.studyId) === undefined) {
            state.loading = true
            // https://stackoverflow.com/questions/47876754/query-firestore-database-for-document-id
            context.root.$store.dispatch('studies/openDBChannel', {
              where: [['__name__', '==', props.studyId]],
            })
              .then(() => {
                state.loading = false
              })
          }
        } catch (e) {
          state.loading = false
          // TODO:  check the error. It might just be that the dbchanell is already open
        }
      })
    })
    return {
      ...toRefs(state),
      subPages,
      study,
      getPageTitle,
    }
  },
})

export default StudyPage

